import React from "react";

import {LanguageSelect, LogoutButton} from "@components";

import './index.less';

export const PartTop = ({withLanguage}) => {
    return (
        <div className="top_wrapper">
            <div className="main_inner">
                {withLanguage && (
                    <div className="top_inner">
                        <div className="top_logo">
                            <img
                                src={`/images/logos/${process.env.REACT_APP_LOGO}`}
                                alt={process.env.REACT_APP_TITLE}
                            />
                        </div>
                        <div className="top_buttons">
                            <LanguageSelect/>
                            <LogoutButton/>
                        </div>
                    </div>
                )}
                {!withLanguage && (
                    <div className="top_inner">
                        <div className="form-part-title">KYC OnBoarding</div>
                        <div className="top_buttons">
                            <LogoutButton/>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
